import { Injectable, Inject } from '@angular/core';

import { EsriModules, ESRI_MODULES_TOKEN } from '../../../tokens/esri.tokens';
import { IAdvancedEsriFeatureOptions } from '../advanced-esri-feature-marker';
import { FsAdvancedEsriFeatureMarker } from '../advanced-esri-feature-marker';
import { FsAdvancedEsriMarker } from '../advanced-esri-marker';
import { IAdvancedEsriMarkerOptions } from '../advanced-marker-options';

/**
 * Factory service for creating ESRI marker instances with injected dependencies
 */
@Injectable({
  providedIn: 'root',
})
export class EsriMarkerFactoryService {
  constructor(@Inject(ESRI_MODULES_TOKEN) private readonly esri: EsriModules) {}

  public createMarker(options?: IAdvancedEsriMarkerOptions): FsAdvancedEsriMarker {
    return new FsAdvancedEsriMarker(this.esri, options);
  }

  public createFeatureMarker(options?: IAdvancedEsriFeatureOptions): FsAdvancedEsriFeatureMarker {
    return new FsAdvancedEsriFeatureMarker(this.esri, options);
  }
}
